import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// Utils
import { auth } from "../utils/firebase/firebase";
// Pages
import LandingAnimation from "../components/landing-animation/LandingAnimation";
import Dashboard2 from "./admin/Dashboard2";
import Login from "./login/Login";
import Logout from "./logout/Logout";
import NotFound from "./not-found/NotFound";
import useRemoteConfig from "../utils/hooks/useRemoteConfig";
// Component
import LoadingModal from "../components/loading/LoadingModal";

// Style
import styles from "./app.module.css";
import { LanguageProvider } from "../utils/language";
import { NotificationProvider } from "../utils/notification_context";
import { ModalProvider } from "../utils/modal-context";
import { AuthProvider } from "../utils/firebase/AuthContext";
import TablePlanner from "./admin/table-planner/TablePlanner";

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const { isLoading: isLandingLoading } = useRemoteConfig();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setIsAuthenticated(!!user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <LoadingModal isLoading={true} />;
  }

  return (
    <div className={styles.baseContainer}>
      <AuthProvider>
        <BrowserRouter>
          <LanguageProvider>
            <NotificationProvider>
              <ModalProvider>
                <Routes>
                  <Route
                    path="/"
                    element={
                      <LandingAnimation isLandingLoading={isLandingLoading} />
                    }
                  />

                  <Route
                    path="/dashboard"
                    element={
                      isAuthenticated ? (
                        <Dashboard2 />
                      ) : (
                        <Navigate to="/login" />
                      )
                    }
                  />

                  <Route
                    path="/planner"
                    element={
                      isAuthenticated ? (
                        <TablePlanner />
                      ) : (
                        <Navigate to="/login" />
                      )
                    }
                  />

                  <Route path="/login" element={<Login />} />
                  <Route path="/logout" element={<Logout />} />

                  <Route path="*" element={<NotFound />} />
                </Routes>
              </ModalProvider>
            </NotificationProvider>
          </LanguageProvider>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
};

export default App;
